import { useState, useEffect } from "react";

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { loginUser, ForgotPassword, ResetPassword } from "./authSlice";
import { selectAuthError, selectAuthStatus, selectCurrentUser } from "./authSlice";
import { fetchagentmarkup } from "./authSlice";
// import { fetchagentmarkup } from "../features/auth/authSlice";

import { Eye, EyeOff } from "lucide-react";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { toast } from 'react-hot-toast';
import { getSiteName } from "../../api/axios";
import { maskPhone } from "../../utils/maskPhone";


const LoginForm = () => {
  const [activeTab, setActiveTab] = useState("login");
  const [ShowForgot, setShowForgot] = useState(false);
  const user = useSelector(selectCurrentUser)

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    franchise: (getSiteName() === 'franchise_goertrip') ? true : false,
  })
  const [formDataReset, setFormDataReset] = useState({
    "email": formData?.email,
    "token": "",
    "otp": "",
    "password": "",
    "password_confirmation": "",
    "phone": ""
  })
  useEffect(() => {
    if (user) {
      navigate('/flight')
    }
  }, []);

  const { ForgotPasswordstatus, ForgotPasswordData, ResetPasswordstatus, ResetPasswordData } = useSelector((state) => state.auth);

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const status = useSelector(selectAuthStatus)
  const error = useSelector(selectAuthError)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }
  const handleChangeResetPassword = (e) => {
    setFormDataReset({
      ...formDataReset,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const resultAction = await dispatch(loginUser(formData))
      if (resultAction.payload.status) {
        toast.success('Login successfully');
        if (loginUser.fulfilled.match(resultAction)) {
          const markup = await dispatch(fetchagentmarkup())
          localStorage.setItem('agent_markup', JSON.stringify(markup.payload.data.data))
          navigate('/flight')
        }
      } else {
        toast.error(resultAction.payload.message);
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong');
    }

  }
  const handleforgotPassword = async (e) => {
    e.preventDefault()
    const CheckUser = {
      "email": formData?.email,
    }
    if (formData.email === '') {
      toast.error('Please enter email id', { autoClose: 2000 });
      return false;
    }
    dispatch(ForgotPassword(CheckUser));
  }
  useEffect(() => {
    if (ForgotPasswordstatus === 'success' && ForgotPasswordData?.status?.success === true) {
      setFormDataReset({
        ...formDataReset,
        ['email']: formData?.email,
        ['reset_token']: ForgotPasswordData?.token,
        ['phone']: ForgotPasswordData?.mobile
      })
      toast.success(ForgotPasswordData?.message, { autoClose: 2000 });
    } else if (ForgotPasswordstatus === 'success' && ForgotPasswordData?.status?.success === false) {
      toast.error(ForgotPasswordData?.message, { autoClose: 2000 });
    }
  }, [ForgotPasswordData, ForgotPasswordstatus]);

  const SubmitforgotPassword = async (e) => {
    e.preventDefault()
    if (formDataReset.otp === '') {
      toast.error('Please enter OTP', { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password === '') {
      toast.error('Please new password', { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation === '') {
      toast.error('Please password confirmation', { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation !== formDataReset.password) {
      toast.error('Please new password and confirm password not matched!', { autoClose: 2000 });
      return false;
    }

    dispatch(ResetPassword(formDataReset));
  }
  useEffect(() => {
    if (ResetPasswordstatus === 'success' && ResetPasswordData?.status?.success === true) {
      toast.success(ResetPasswordData?.message, { autoClose: 2000 });
      window.location.reload()
    } else if (ResetPasswordstatus === 'success' && ResetPasswordData?.status?.success === false) {
      toast.error(ResetPasswordData?.message, { autoClose: 2000 });
    }
  }, [ResetPasswordData, ResetPasswordstatus]);

  return (
    <>
      <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
        <div className="mb-6 text-center">
          {/*<img
                src="/HolidayFly.svg"
                alt="Logo"
                className="h-12  inline-block"
              />*/}
        </div>
        {/* <h2 className="text-2xl font-bold mb-6 text-center">Login</h2> */}
        {error && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">
            {error.message || 'Login failed'}
          </div>
        )}

        {!ShowForgot && (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 mb-2" htmlFor="password">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center justify-between mb-6">
              <a href="#" onClick={() => setShowForgot(!ShowForgot)} className="text-sm text-blue-600 hover:underline">
                Lost Your Password?
              </a>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="bg-[#f4a406] text-white px-6 py-2 rounded-md hover:bg-yellow-500"
              >
                {status === 'loading' ? 'Logging in...' : 'Login'}
              </button>
            </div>
          </form>
        )}

        {ShowForgot && (
          <>
            {ForgotPasswordstatus !== 'success' && (
              <form onSubmit={handleforgotPassword}>
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div className="flex items-center justify-between mb-6">
                  <a href="#" onClick={() => setShowForgot(!ShowForgot)} className="text-sm text-blue-600 hover:underline">
                    Login?
                  </a>
                  <button
                    type="submit"
                    disabled={ForgotPasswordstatus === 'pendig'}
                    className="bg-[#f4a406] text-white px-6 py-2 rounded-md hover:bg-yellow-500"
                  >
                    {ForgotPasswordstatus === 'pendig' ? 'Please wait...' : 'Submit'}
                  </button>
                </div>
              </form>
            )}
            {ForgotPasswordstatus === 'success' && (
              <form onSubmit={SubmitforgotPassword}>
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="email">
                    Enter OTP
                  </label>
                  <input
                    type="number"
                    id="otp"
                    name="otp"
                    value={formDataReset.otp}
                    onChange={handleChangeResetPassword}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="password">
                    New Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      value={formDataReset.password}
                      onChange={handleChangeResetPassword}
                      className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="password">
                    Password Confirmation
                  </label>
                  <div className="relative">
                    <input
                      type={showPasswordConfirm ? "text" : "password"}
                      id="password_confirmation"
                      name="password_confirmation"
                      value={formDataReset.password_confirmation}
                      onChange={handleChangeResetPassword}
                      className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      {showPasswordConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>


                <small className="text-sm text-gray-600 text-right">
                  OTP has been shared with your mobile ending in {maskPhone(formDataReset?.phone, 2)}
                </small>
                <div className="flex items-center justify-between mb-6">

                  <a href="#" onClick={() => setShowForgot(!ShowForgot)} className="text-sm text-blue-600 hover:underline">
                    Login?
                  </a>

                  <button
                    type="submit"
                    disabled={ResetPasswordstatus === 'pendig'}
                    className="bg-[#f4a406] text-white px-6 py-2 rounded-md hover:bg-yellow-500"
                  >
                    {ResetPasswordstatus === 'pendig' ? 'Please wait...' : 'Submit'}
                  </button>
                </div>

              </form>
            )}

          </>
        )}

      </div>
    </>
  )
}

export default LoginForm